/* eslint-disable indent */
import {
	Box,
	Button,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
} from '@mui/material'
import React from 'react'
import { WorkItem } from '../../../types/Work/WorkItem'
import { StyledTableCell } from '../../core/StyledTableCell'
import { ViewAttachmentsPopup } from '../../attachments/ViewAttachmentsPopup'
import { getAttachment, deleteAttachment, listAttachments, uploadAttachments } from '../../../services/attachmentService'
import { QCWorkItemRow } from './QCWorkItemRow'

type QCBacklogListProps = {
	hierarchy: WorkItem | undefined
}

export function QCBacklogList({  hierarchy }: QCBacklogListProps) {
	const [isViewingAttachment, setIsViewingAttachment] = React.useState<boolean>(false)
	const [attachmentWorkitemId, setAttachmentWorkitemId] = React.useState<number>()

	const selectAttachments = (workItemId: number) => {
		setAttachmentWorkitemId(workItemId)
		setIsViewingAttachment(true)
	}

	return (
		<>
			<TableContainer
				sx={{
					height: '100%',
					width: '100%',
					overflowX: 'scroll',
					overflowY: 'scroll',
				}}
			>
				<Table stickyHeader>
					<TableHead>
						<TableRow>
							<StyledTableCell />
							<StyledTableCell align='center'>Type</StyledTableCell>
							<StyledTableCell align='center'>Craft</StyledTableCell>
							<StyledTableCell>Name</StyledTableCell>
							<StyledTableCell align='center'>Info</StyledTableCell>
							<StyledTableCell align='center'>Request At</StyledTableCell>
							<StyledTableCell align='center'>Attachments</StyledTableCell>
							<StyledTableCell colSpan={2} align='center'>Comment</StyledTableCell>
							<StyledTableCell align='right'>Qty Budget</StyledTableCell>
							<StyledTableCell align='right'>Quantity Completed</StyledTableCell>
							<StyledTableCell align='right'>UOM</StyledTableCell>
							<StyledTableCell align='right'>Qty Earned</StyledTableCell>
							<StyledTableCell align='right'>Qty Remaining</StyledTableCell>
							<StyledTableCell align='right'>% Complete</StyledTableCell>
							<StyledTableCell align='right'>Qty Inspected</StyledTableCell>
							<StyledTableCell align='right'>Budgeted Hours</StyledTableCell>
							<StyledTableCell align='right'>Earned Hours</StyledTableCell>
							<StyledTableCell align='right'>Actual Hours</StyledTableCell> {/* Burned Hours */}
							<StyledTableCell align='right'>PF</StyledTableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{hierarchy && (
							<QCWorkItemRow
								workItem={hierarchy}
								key={hierarchy.id}
								selectAttachments={selectAttachments}
								layer={1}
							/>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			{attachmentWorkitemId && (
				<ViewAttachmentsPopup
					handleClose={() => {
						setIsViewingAttachment(false)
						setAttachmentWorkitemId(undefined)
					}}
					open={isViewingAttachment}
					itemId={attachmentWorkitemId}
					attachmentOperations={{
						listAttachments: (id) => listAttachments(id, 'workitem', null),
						getAttachment: (id) => getAttachment(id, 'workitem', null),
						uploadAttachment: (files, id, overwrite, newAnnotations, setUploadProgress) =>
							uploadAttachments(files, id, overwrite, 'workitem', newAnnotations, setUploadProgress),
						deleteAttachment: (id) => deleteAttachment(id, 'workitem'),
					}}
				/>
			)}
			
			
		</>
	)
}
